import { Link } from '@framework/router/Next/Link';
import Button from '@creditflowresearch/uilib/Button';
import { useGetPricedDealsLink } from '@/creditflowresearch/ui/components/creditFlow/articles/common/PricedDealsLinks/useGetPricedDealsLink';

export const PricedDealsLinks = () => {
  const links = useGetPricedDealsLink();

  return (
    <>
      { links.map(({ key, pathname, query, tooltip }) => (
        <Button
          key={ key }
          as={ Link }
          to={ { pathname, query: query as Record<string, string> } }
          variant="outline"
          size="S"
          fit={ { sm: 'full', md: 'full' } }
          dataTest={ `${ key }Link` }
        >
          { tooltip }
        </Button>
      )) }
    </>
  );
};
